import React, { useId } from 'react';

import { token } from '@atlaskit/tokens';

export const CardCoverArtwork = (): React.JSX.Element => {
	const id = useId();
	const gridId = `${id}-grid`;
	const fadeId = `${id}-fade`;
	const maskId = `${id}-mask`;

	return (
		<svg width="100%" height="100%" aria-hidden="true" focusable="false">
			<defs>
				<pattern id={gridId} width="32" height="32" patternUnits="userSpaceOnUse" x="14" y="8">
					<path
						d="M 32 0 H 0 V 32"
						fill="none"
						stroke={token('color.border')}
						strokeDasharray="2 2"
					/>
				</pattern>
				<linearGradient id={fadeId} x1="0" y1="0" x2="0" y2="1">
					<stop offset="55%" stopColor="white" />
					<stop offset="100%" stopColor="white" stopOpacity="0" />
				</linearGradient>
				<mask id={maskId}>
					<rect width="100%" height="100%" fill={`url(#${fadeId})`} />
				</mask>
			</defs>
			<rect width="100%" height="100%" fill={`url(#${gridId})`} mask={`url(#${maskId})`} />
		</svg>
	);
};
